import {StyleSheet} from 'react-native';
import {Colors} from '../../styles/Colors';
import ConstantStyles from '../../styles/ConstantStyles';
import {colorPalette} from '../../theme';

export default StyleSheet.create({
  container: {
    backgroundColor: colorPalette.whiteGrey0,
    width: 40,
    height: 40,
    borderRadius: 18,
    shadowColor: Colors.shadow_1,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.5,
    shadowRadius: 3,
    elevation: 10,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
